import z from "zod";

export const teamFormSchema = z.object({
	name: z.string(),
	capabilities: z.array(z.string()).min(0).default([]),
	members: z.array(z.string()).min(1),
	teamLeaders: z.array(z.string()).min(0).default([]),
	source: z.string().nullish(),
	identifier: z.string().nullish(),
});

export type TeamFormSchema = z.infer<typeof teamFormSchema>;
